import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

// Lightweight camera QR scanner. Calls onScan(decodedText) once on first successful read.
export default function QrScanner({ onScan, onError }) {
  const ref = useRef(null);
  const scannerRef = useRef(null);
  const doneRef = useRef(false);

  useEffect(() => {
    const id = "qr-reader-region";
    const el = ref.current;
    if (!el) return;
    el.id = id;
    const scanner = new Html5Qrcode(id, { verbose: false });
    scannerRef.current = scanner;

    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 220, height: 220 } },
        (decodedText) => {
          if (doneRef.current) return;
          doneRef.current = true;
          onScan?.(decodedText);
        },
        () => {}
      )
      .catch((e) => onError?.(e));

    return () => {
      try {
        if (scannerRef.current?.isScanning) {
          scannerRef.current.stop().then(() => scannerRef.current.clear()).catch(() => {});
        } else {
          scannerRef.current?.clear?.();
        }
      } catch (e) {}
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <style>{`
        #qr-reader-region { width: 100% !important; height: 260px !important; }
        #qr-reader-region video {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          display: block;
        }
        #qr-reader-region canvas { display: none !important; }
        #qr-reader-region img[alt="Info icon"], #qr-reader-region a { display: none !important; }
      `}</style>
      <div
        ref={ref}
        data-testid="qr-scanner-region"
        className="w-full rounded-2xl overflow-hidden border border-white/10 bg-black relative"
      />
    </>
  );
}
